import { Injectable } from '@angular/core';
import {
  CORE_ACTIONS,
  ToggleErrorModalAction,
  ToggleUpgradeInjectorStatusAction
} from '../constants/core-actions.constant';
import { ActionCreatorAbstract } from '../classes/action-creator.abstract';
import { IGeneralErrorState } from '@ispm/core/core.reducer';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';

@Injectable()
export class CoreActionCreatorService extends ActionCreatorAbstract {
  constructor(store: Store<IgenomicsState>) {
    super(store, 'core');
  }

  setLoader(loaderState: boolean) {
    this.store.dispatch({
      type: CORE_ACTIONS.SET_LOADER,
      payload: loaderState
    });
  }

  public fetchEnvironmentDetails(): Observable<any> {
    return this.store.select('environmentDetails')
  }

  setErrorModal(status: boolean, title: string = '', content: string = '', btntxt: string = '', callback: any = null ) {
    this.store.dispatch(new ToggleErrorModalAction({ status, title, content, btntxt, callback}));
  }

  getErrorState(): Observable<IGeneralErrorState> {
    return this.store.select('generalError');
  }

  setUpgradeInjectorStatus(status) {
    this.store.dispatch(new ToggleUpgradeInjectorStatusAction(status));
  }

  getUpgradeInjectorStatus(): Observable<boolean> {
    return this.store.select('upgradeInjectorStatus');
  }

  setIsEmbedded(isEmbedded: boolean) {
    this.store.dispatch({
      type: CORE_ACTIONS.SET_IS_EMBEDDED,
      payload: isEmbedded
    });
  }

  isEmbedded(): Observable<boolean> {
    return this.store.select('isEmbedded');
  }

  skipUserInteractionUpdate(skipUserInteraction: boolean) {
    this.store.dispatch({
        type: CORE_ACTIONS.SKIP_USER_INTERACTION_UPDATE,
        payload: skipUserInteraction
    });
  }

  pageIsReloaded(): boolean {
    // detects if page is reloaded
    if (window.performance && performance.navigation.type == performance.navigation.TYPE_RELOAD) {
      return true;
    }
    return false;
  }

}
